import React from 'react';
import ImageBase from './ImageBase';

type TBasic = {
  alt: string;
  src: string;
  loading?: 'lazy' | 'eager' | 'auto';
  width?: string;
  height?: string;
  className?: string;
  srcSet?: string;
  style?: React.CSSProperties;
  title?: string;
  fetchpriority?: 'high' | 'low' | 'auto';
  decoding?: 'async' | 'sync' | 'auto';
  aspectRatio?: 'landscape' | 'portrait' | 'square';
  fit?: boolean;
  useUploader?: boolean;
  isUploaded?: boolean;
  onDelete?: () => void;
  onRotate?: () => void;
  onHeart?: () => void;
  onUploadError?: () => void;
  onUploadSuccess?: (file: File) => void;
  onUpload?: (file: File) => Promise<any> | void;
  showActionIcons?: boolean;
};

const Basic = ({ aspectRatio = 'square', fit, ...props }: TBasic) => {
  const aspectRatioClass = aspectRatio ? `hz-Image--${aspectRatio}` : '';
  const fitClass = fit ? 'hz-Image--fit' : '';
  const combinedClassName = `${props.className || ''} ${aspectRatioClass} ${fitClass}`.trim();

  return <ImageBase {...props} as="img" className={combinedClassName} />;
};

export default Basic;
